import {
  LucideAppWindow,
  LucideBarChart3,
  LucideBug,
  LucideCalendar,
  LucideChevronDown,
  LucideChevronRight,
  LucideCircleHelp,
  LucideClock,
  LucideCloud,
  LucideDatabase,
  LucideFileSearch,
  LucideFileText,
  LucideFormInput,
  LucideGift,
  LucideHeadphones,
  LucideIdCard,
  LucideLayoutDashboard,
  LucideLightbulb,
  LucideLogOut,
  LucideMoon,
  LucideMapPin,
  LucidePhone,
  LucidePlusCircle,
  LucideSearch,
  LucideSettings,
  LucideStore,
  LucideSun,
  LucideUser,
  LucideUsers,
  LucideX,
  provideLucideIcons,
} from '@lucide/angular';

/** Ícones Lucide usados no menu e na busca global (rotas → resolveNavIcon). */
export const provideNavLucideIcons = () =>
  provideLucideIcons(
    LucideChevronDown,
    LucideChevronRight,
    LucideSearch,
    LucideX,
    LucideLayoutDashboard,
    LucideAppWindow,
    LucideCalendar,
    LucideBarChart3,
    LucideStore,
    LucideFileText,
    LucideFileSearch,
    LucideDatabase,
    LucidePlusCircle,
    LucideFormInput,
    LucideSettings,
    LucideCloud,
    LucideBug,
    LucideMapPin,
    LucideUser,
    LucideUsers,
    LucideIdCard,
    LucideGift,
    LucideClock,
    LucideHeadphones,
    LucidePhone,
    LucideLightbulb,
    LucideCircleHelp,
    LucideLogOut,
    LucideSun,
    LucideMoon,
  );
